function MapSettingState() {
    "use strict";

    this.IsZones = false;
    this.IsStartDate = false;
    this.IsAddresses = false;
    this.IsConnectedTracks = false;
    this.IsNumberedLabels = false;
    this.IsEvents = false;
    this.IsGpsTrackpoints = false;
    this.IsCellTrackpoints = false;
    this.IsTripsVisits = false;
}
if (typeof exports !== 'undefined') {
    module.exports = MapSettingState;
}